import {
    FETCH_SUPPLIER_REQUEST,
    FETCH_SUPPLIER_SUCCESS,
    FETCH_SUPPLIER_FAILURE,
  } from "./AutoCompleteSupplierTypes";
  
  const initialState = {
    loading: false,
    supplier: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SUPPLIER_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_SUPPLIER_SUCCESS:
        return {
          loading: false,
          supplier: action.payload,
          error: "",
        };
      case FETCH_SUPPLIER_FAILURE:
        return {
          loading: false,
          supplier: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  